export default __webpack_public_path__ + "static/char-s-32-en-b516a93c2276253720bb02ede1cc53df.png";